<script setup lang="ts">
const { loggedIn } = useUserSession()
</script>

<template>
    <div class="flex min-h-dvh flex-col">
        <AppHeader />

        <main class="page-in mx-auto w-full max-w-[1500px] flex-1 px-4 pb-28 pt-0 sm:px-6">
            <slot />
        </main>

        <MobileNav v-if="loggedIn" />
    </div>
</template>
